var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("system.modify_pwd"),
            "close-on-click-modal": false,
            visible: _vm.dialogPwdVisible,
            width: "509px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogPwdVisible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("system.password_details")) + " "),
          ]),
          _c("div", { staticClass: "section-tip" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("tips.update_your_password_entering_new_one")) +
                " "
            ),
          ]),
          _c(
            "div",
            { staticClass: "modify-password" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "200px",
                    rules: _vm.rules,
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("system.password"),
                                prop: "password",
                                required: "",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-password",
                                attrs: {
                                  size: "small",
                                  placeholder: _vm.$t("system.password"),
                                  autocomplete: "off",
                                  clearable: "",
                                  "show-password": "",
                                },
                                model: {
                                  value: _vm.form.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "password", $$v)
                                  },
                                  expression: "form.password",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("br"),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogPwdVisible = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-submit",
                      attrs: { type: "info", disabled: _vm.listLoading },
                      on: {
                        click: function ($event) {
                          return _vm.submitModifyPwd("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("components.submit")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }